import { number } from 'yup';

export const fourNumberExp = /^\d{4}$/;
export const numberRequiredValidation = (field?: string) =>
  number()
    .nullable()
    .required(field ? `${field} is required` : 'Please enter a number');
export const numberOptionalValidation = number().notRequired().nullable();
